import { useIntl } from 'react-intl';

import { useAppDispatch } from '@/shared/hooks';

import { ModalID, modalModel } from '@/entities/modal';
import { reportsModel } from '@/entities/reports';

export const useRemoveReportSignature = (reportID: string) => {
  const dispatch = useAppDispatch();

  const { formatMessage } = useIntl();

  return () => {
    dispatch(
      modalModel.actions.openModal({
        modalID: ModalID.Confirm,
        data: {
          title: formatMessage({
            id: 'dismissSignature.modalTitle',
            defaultMessage: 'Remove the signature from the report?',
          }),
          description: formatMessage({
            id: 'dismissSignature.removeModalDescription',
            defaultMessage:
              'All signatures and signing dates will be removed from the report. You will be able to sign it again.',
          }),
          okText: formatMessage({
            id: 'dismissSignature.yesAndRemove',
            defaultMessage: 'Yes, remove',
          }),
          onConfirm: async () => {
            dispatch(modalModel.actions.setConfirmModalLoading(true));
            try {
              const response = await dispatch(
                reportsModel.thunks.unsignReport({ ReportID: reportID }),
              ).unwrap();

              if (response.Report) {
                dispatch(reportsModel.actions.setNewestOne(response.Report));
              }
            } catch {
              // NOTE: errorMiddleware already shows the toast; only the modal needs closing here.
            } finally {
              dispatch(modalModel.actions.setConfirmModalLoading(false));
              dispatch(modalModel.actions.closeModal(ModalID.Confirm));
            }
          },
        },
      }),
    );
  };
};
